<div class="alert {{alertClass}}">
  <ng-content></ng-content>
</div>
